// Generated from the backend maintained pattern dialect.
/**
 * Shared browser/backend regex dialect. One variable-count atom and no branching or groups
 * bound native RegExp work on the existing 512-character input limit.
 */
export function isSupportedBillingPattern(pattern: unknown): pattern is string {
  if (typeof pattern !== 'string' || pattern.length < 2 || pattern.length > 256 ||
    pattern[0] !== '^' || pattern[pattern.length - 1] !== '$') {
    return false;
  }
  let variableAtoms = 0;
  let index = 1;
  const end = pattern.length - 1;
  while (index < end) {
    const char = pattern[index++];
    if (char === '\\') {
      if (index >= end || !/^[dDsSwWtrn.$^{}()[\]|?*+\\/-]$/.test(pattern[index++])) {
        return false;
      }
    } else if (char === '[') {
      const start = index;
      if (pattern[index] === '^') index++;
      while (index < end && pattern[index] !== ']') {
        if (pattern[index++] === '\\') {
          if (index >= end || !/^[dDsSwWtrn.$^{}()[\]|?*+\\/-]$/.test(pattern[index++])) return false;
        }
      }
      if (index >= end || index === start || (index === start + 1 && pattern[start] === '^')) return false;
      index++;
    } else if (/[\^$.*+?{}()|\]]/.test(char) || /[\r\n]/.test(char)) {
      return false;
    }
    if (pattern[index] === '?') {
      index++;
      variableAtoms++;
    } else if (pattern[index] === '{') {
      const count = /^\{(\d{1,3})(?:,(\d{1,3}))?\}/.exec(pattern.slice(index));
      if (!count) return false;
      const minimum = Number(count[1]);
      const maximum = typeof count[2] === 'string' ? Number(count[2]) : minimum;
      if (minimum > maximum || maximum > 512) return false;
      if (minimum !== maximum) variableAtoms++;
      index += count[0].length;
    }
    if (variableAtoms > 1) return false;
  }
  try {
    new RegExp(pattern, 'u');
    return true;
  } catch {
    return false;
  }
}

export function matchesBillingPattern(pattern: string, value: string): boolean {
  if (!isSupportedBillingPattern(pattern) || value.length > 1024 || Array.from(value).length > 512) return false;
  // JS "$" can also match before a final newline. Whole-value comparison closes that gap.
  return new RegExp(pattern, 'u').exec(value)?.[0] === value;
}
